var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    { staticClass: "d-flex justify-content-center company-edit-menu" },
    [
      _c("div", { staticClass: "d-flex flex-column" }, [
        _c("span", { staticClass: "link-wrapper" }, [
          _c(
            "span",
            {
              on: {
                click: function($event) {
                  _vm.setCompanyStep("companies-info")
                }
              }
            },
            [
              _c(
                "router-link",
                {
                  class: _vm.isActiveLinkClass("companies-info"),
                  attrs: {
                    to:
                      "/companies/edit/" +
                      _vm.$route.params.id +
                      "?tab=companies-info"
                  }
                },
                [_vm._v("\n          Company info\n        ")]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "link-wrapper" }, [
          _c(
            "span",
            {
              on: {
                click: function($event) {
                  _vm.setCompanyStep("companies-settings")
                }
              }
            },
            [
              _c(
                "router-link",
                {
                  class: _vm.isActiveLinkClass("companies-settings"),
                  attrs: {
                    to:
                      "/companies/edit/" +
                      _vm.$route.params.id +
                      "?tab=companies-settings"
                  }
                },
                [_vm._v("\n          Company settings\n        ")]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "link-wrapper" }, [
          _c(
            "span",
            {
              on: {
                click: function($event) {
                  _vm.setCompanyStep("companies-map")
                }
              }
            },
            [
              _c(
                "router-link",
                {
                  class: _vm.isActiveLinkClass("companies-map"),
                  attrs: {
                    to:
                      "/companies/edit/" +
                      _vm.$route.params.id +
                      "?tab=companies-map"
                  }
                },
                [_vm._v("\n          Coverage\n        ")]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "link-wrapper" }, [
          _c(
            "span",
            {
              on: {
                click: function($event) {
                  _vm.setCompanyStep("companies-pricing")
                }
              }
            },
            [
              _c(
                "router-link",
                {
                  class: _vm.isActiveLinkClass("companies-pricing"),
                  attrs: {
                    to:
                      "/companies/edit/" +
                      _vm.$route.params.id +
                      "?tab=companies-pricing"
                  }
                },
                [_vm._v("\n          Pricing\n        ")]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "link-wrapper" }, [
          _c(
            "span",
            {
              on: {
                click: function($event) {
                  _vm.setCompanyStep("companies-availability")
                }
              }
            },
            [
              _c(
                "router-link",
                {
                  class: _vm.isActiveLinkClass("companies-availability"),
                  attrs: {
                    to:
                      "/companies/edit/" +
                      _vm.$route.params.id +
                      "?tab=companies-availability"
                  }
                },
                [_vm._v("\n          Availability\n        ")]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "link-wrapper" }, [
          _c(
            "span",
            {
              on: {
                click: function($event) {
                  _vm.setCompanyStep("companies-email")
                }
              }
            },
            [
              _c(
                "router-link",
                {
                  class: _vm.isActiveLinkClass("companies-email"),
                  attrs: {
                    to:
                      "/companies/edit/" +
                      _vm.$route.params.id +
                      "?tab=companies-email"
                  }
                },
                [_vm._v("\n          Email templates\n        ")]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "link-wrapper" }, [
          _c(
            "span",
            {
              on: {
                click: function($event) {
                  _vm.setCompanyStep("web-quote")
                }
              }
            },
            [
              _vm.$_can("companies.mod.update")
                ? _c(
                    "router-link",
                    {
                      class: _vm.isActiveLinkClass("web-quote"),
                      attrs: {
                        to:
                          "/companies/edit/" +
                          _vm.$route.params.id +
                          "?tab=web-quote"
                      },
                      on: {
                        click: function($event) {
                          _vm.setCompanyStep("web-quote")
                        }
                      }
                    },
                    [_vm._v("\n          Web quote\n        ")]
                  )
                : _vm._e()
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "link-wrapper" }, [
          _vm.$_can("companies.mod.update")
            ? _c("span", [
                _c(
                  "div",
                  {
                    staticClass: "d-flex align-items-center",
                    attrs: { id: "headingCompanySubMenu" }
                  },
                  [
                    _c(
                      "a",
                      {
                        class: { collapsed: !_vm.mod24SettingsOpened },
                        attrs: {
                          href: "#",
                          "data-toggle": "collapse",
                          "data-target": "#collapseCompanySubMenu",
                          "data-controls": "#collapseCompanySubMenu"
                        },
                        on: {
                          click: function($event) {
                            _vm.mod24SettingsOpened = !_vm.mod24SettingsOpened
                          }
                        }
                      },
                      [_vm._v("\n            Mod24 Settings\n          ")]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "ml-3 pointer",
                      class: {
                        "mod-icon-minus": _vm.mod24SettingsOpened,
                        "mod-icon-plus": !_vm.mod24SettingsOpened
                      },
                      on: {
                        click: function($event) {
                          _vm.mod24SettingsOpened = !_vm.mod24SettingsOpened
                        }
                      }
                    })
                  ]
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "collapse",
            class: { show: _vm.mod24SettingsOpened },
            attrs: {
              id: "collapseCompanySubMenu",
              "aria-expanded": "false",
              "aria-labelledby": "headingCompanySubMenu"
            }
          },
          [
            _c("div", { staticClass: "accordion-sub-menu" }, [
              _c("span", { staticClass: "link-wrapper" }, [
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        _vm.setCompanyStep("getting-started")
                      }
                    }
                  },
                  [
                    _c(
                      "router-link",
                      {
                        class: _vm.isActiveLinkClass("getting-started"),
                        attrs: {
                          to:
                            "/companies/edit/" +
                            _vm.$route.params.id +
                            "?tab=getting-started"
                        }
                      },
                      [_vm._v("\n              Getting started\n            ")]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "link-wrapper" }, [
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        _vm.setCompanyStep("companies-licence")
                      }
                    }
                  },
                  [
                    _c(
                      "router-link",
                      {
                        class: _vm.isActiveLinkClass("companies-licence"),
                        attrs: {
                          to:
                            "/companies/edit/" +
                            _vm.$route.params.id +
                            "?tab=companies-licence"
                        }
                      },
                      [_vm._v("\n              Company Licence\n            ")]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "link-wrapper" }, [
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        _vm.setCompanyStep("companies-tier")
                      }
                    }
                  },
                  [
                    _c(
                      "router-link",
                      {
                        class: _vm.isActiveLinkClass("companies-tier"),
                        attrs: {
                          to:
                            "/companies/edit/" +
                            _vm.$route.params.id +
                            "?tab=companies-tier"
                        }
                      },
                      [_vm._v("\n              Tier\n            ")]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "link-wrapper" }, [
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        _vm.setCompanyStep("website-details")
                      }
                    }
                  },
                  [
                    _c(
                      "router-link",
                      {
                        class: _vm.isActiveLinkClass("website-details"),
                        attrs: {
                          to:
                            "/companies/edit/" +
                            _vm.$route.params.id +
                            "?tab=website-details"
                        }
                      },
                      [_vm._v("\n              Website Details\n            ")]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "link-wrapper" }, [
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        _vm.setCompanyStep("billing-info")
                      }
                    }
                  },
                  [
                    _c(
                      "router-link",
                      {
                        class: _vm.isActiveLinkClass("billing-info"),
                        attrs: {
                          to:
                            "/companies/edit/" +
                            _vm.$route.params.id +
                            "?tab=billing-info"
                        }
                      },
                      [_vm._v("\n              Billing info\n            ")]
                    )
                  ],
                  1
                )
              ])
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ef7d161c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef7d161c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/companies/CompanyEditMenu.vue
// module id = null
// module chunks = 